// extracted by mini-css-extract-plugin
export default {"details":"styles_details__l2tL7","detail":"styles_detail__mnoPH","imageWrapper":"styles_imageWrapper__n0xr0"};